import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useToggle } from '../../../infra/small-tools/use-toggle';
import { ReportingAiBotModal } from './reporting-ai-bot-modal';
import { BotToggleButton } from './bot-toggle-button';
import { useShowReportingBotButton } from './use-show-reporting-bot-button';
import { useApiQuery } from '../../../infra/api';
import { endpoints } from './network';
import { shouldAutoOpenRecentChat } from './utils';
import { RudderstackTracker } from '../../../infra/observability/rudderstack/rudderstack';
import { REPORTING_BOT_MODAL_OPENED } from '../../../infra/observability/rudderstack/events';
import { getViewerIdAndKind, useSession } from '../../../infra/session';
export var ReportingAiBotContainer = function () {
    var showReportingBot = useShowReportingBotButton();
    var modal = useToggle(false);
    var session = useSession().data;
    var viewerIdAndKind = getViewerIdAndKind(session);
    var barberId = viewerIdAndKind === null || viewerIdAndKind === void 0 ? void 0 : viewerIdAndKind.id;
    var _a = useApiQuery({
        endpoint: endpoints.chatHistoryQuery,
        payload: {
            barberId: barberId,
        },
        options: {
            refetchOnWindowFocus: false,
            enabled: showReportingBot && !!barberId,
        },
    }), chatHistory = _a.data, isHistoryLoading = _a.isLoading;
    useEffect(function () {
        if (showReportingBot && modal.isOn) {
            RudderstackTracker.getInstance().track(REPORTING_BOT_MODAL_OPENED);
        }
    }, [showReportingBot, modal.isOn]);
    var autoOpenResult = chatHistory ? shouldAutoOpenRecentChat(chatHistory) : null;
    if (!showReportingBot) {
        return null;
    }
    return (_jsxs(_Fragment, { children: [_jsx(BotToggleButton, { onClick: modal.toggle }), _jsx(ReportingAiBotModal, { isOpen: modal.isOn, onClose: modal.setOff, chatHistory: chatHistory || [], isHistoryLoading: isHistoryLoading, autoOpenResult: autoOpenResult })] }));
};
